import { Component, OnInit, OnChanges, SimpleChanges, DoCheck, ElementRef, ViewChild } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { OpenStreetMapComponent } from 'src/app/components/open-street-map/open-street-map.component';
import { verifyHostBindings } from '@angular/compiler';

@Component({
  selector: "app-open-street-map",
  templateUrl: "./open-street-map-widget.component.html",
  styleUrls: ["./open-street-map-widget.component.css"],
})
export class OpenStreetMapWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  @ViewChild('streetMap', { read: OpenStreetMapComponent, static: true }) map: OpenStreetMapComponent;
  
  offset: number;

  public override config: any;
  
  private colours: string[];

  liveDataOnly(): boolean {
    return false;
    //return this.c.period == null || this.c.period == "";
  }

  override eventTypes: string[] = ['timeSeriesHover', 'timeSeriesUnhover', 'timeSeriesSelect', 'timeSeriesUnselect'];
  override timeSeriesEvent(type: string, uri: string): void {
    // todo: implement bounce pin on hover
    // todo: implement popup on select
  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetBeforeInit() {
    this.config = <any>this.config;
    console.log(this.config);
    var currentTime = new Date();

    // get the offset from UTC to Local in milliseconds
    this.offset = -(new Date().getTimezoneOffset() * 60 * 1000);
    var series = [];

    this.colours = [
      '#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];

    for (var i in this.config.dynamicTimeSeriesList) {
      var ts = <any>this.config.dynamicTimeSeriesList[i];
      if (ts.colour == null){
        ts.colour = this.colours[i];
      }
      // load geojson
    }
  }

  widgetAfterInit() {
    setTimeout(() => {
      if (this.config.layers){
        for (let layer of this.config.layers){
          this.map.loadLinkLayer(layer.name, layer.onByDefault, layer.accessDirectly, layer.type, layer.url);
        }
      }
    },2000);
  }

  onHover(uri: string){
    this.events.trigger('timeSeriesHover', uri, null);
  }
   
  onUnhover(uri: string){
    this.events.trigger('timeSeriesUnhover', uri, null);
  }

  refresh() {
    this.ngOnInit();
  }

  widgetDataLoaded(s: SharedSeries) {
    if (s == null) return;
    
    var colour = this.colours[s.dynamicIndex];
    var tsdu = this.config.dynamicTimeSeriesList.find(t => t.uri == s.uri);
    var tsdi = this.config.dynamicTimeSeriesList[s.index] as any;
    var zoom = this.config.zoomLevel;
    var weight = tsdi.weight;
    
    if (tsdi.colour && tsdi.uri && tsdi.uri.indexOf(':') < 0){
      colour = tsdi.colour;
    }
    if (tsdi.type == "fixed"){
      console.log("Load Static Site (" + s.latitude + "," + s.longitude + ")");
      this.map.loadStaticSite(s.uri, s, colour, zoom, tsdi, this.onLeftClick);
    } 
    else if (tsdi.type == "heatmap") {
      let useRssi = tsdu.useRssi

      if(!useRssi)
      {
        useRssi = false;
      }

      this.map.loadHeatmap(s.uri, s.values, colour, weight, useRssi);
    }     
    else if (tsdi.type == "geojson") {
      for (let v of s.values) {
        this.map.loadGeoJson(s.uri, v.value, colour);
      }
    } else /*tracker*/{
      this.map.loadTracker(s.uri, s.values, colour, tsdi.type);
    }
  }

  widgetLiveDataLoaded(s: any) {
    //todo: implement for live data feeds
  }

  onLeftClick(marker, ts) {

    if (ts.leftClickWidget){
      var ids = ts.leftClickWidget.replace(':','/') + "/" + ts.uri;
      var popupHeight = 150;
      if (ts.popupHeight){
        popupHeight = ts.popupHeight;
      }
      marker.bindPopup("<iframe iframe-resizer=\"indicium\" height=\"" + popupHeight + "\" src=\"#/dashboard/" + ids + "\" frameborder=\"0\" scrolling=\"no\" onload=\"obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px'\"></iframe>").openPopup();
    }
  
  }

  widgetDataLoadTimeout(){
    
  }

  widgetDataAdded(s: SharedPoint) {
  
  }

  ngDoCheck() {

  }

  ngOnChanges(changes: SimpleChanges) {

  
  }
  



}
